import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_100: FaireProductEntity = {
  token: "legacy_prod_abbott-100",
  type: "product",
  name: 'Classic Plant Mister Teal 8" H, 22 oz (Clearance)',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a0ac4c18e546e35d14e12f8c7fc1e9544473dc0d1cbc7c50dcf4d74c01fc9fa8.jpeg",
  priceDollars: 18,
  msrpDollars: 32,
  subcategory: "Garden Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
